import secondaryComponents from "..";
import { BankEmptyIcon } from "../../../assets/svgIcons";
import useAccountsListLogic from "./useAccountsListLogic";
import { RoutedModal } from "../../common";

const AllAccountsList = ({
  accounts,
  handleFetchAccountsList,
  metaDetails,
  gotoPage,
}) => {
  const {
    instance,
    selectedBankAccount,
    selectedChartAccount,
    setSelectedBankAccount,
    bankInfo,
    isFetchingBankInfo,
    selectedDeleteAccount,
    setSelectedDeleteAccount,
    setSelectedChartAccount,
  } = useAccountsListLogic({
    accounts,
    handleFetchAccountsList,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
      >
        <div className="text-center mt-5">
          <BankEmptyIcon />
          <h5>You have no chart of accounts</h5>
          <p>When you do, they would appear here.</p>
        </div>
      </secondaryComponents.TableHelper>

      {accounts?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      {/* update bank account */}
      <secondaryComponents.LoaderHelper isLoading={isFetchingBankInfo}>
        <RoutedModal
          isActive={!!selectedBankAccount}
          closeModal={() => setSelectedBankAccount(null)}
          width={700}
          headerTitle="Update Bank Account"
          headerDescription="Make changes to your chart account details to keep your financial records accurate and up-to-date."
          style={{ height: "auto" }}
        >
          <secondaryComponents.AddBankAccount
            closeWidget={() => setSelectedBankAccount(null)}
            handleFetchAccountsList={handleFetchAccountsList}
            isEditMode={true}
            bankInfo={bankInfo}
          />
        </RoutedModal>
      </secondaryComponents.LoaderHelper>

      {/* update chart account */}
      <secondaryComponents.LoaderHelper isLoading={isFetchingBankInfo}>
        <RoutedModal
          isActive={!!selectedChartAccount}
          closeModal={() => setSelectedChartAccount(null)}
          width={700}
          headerTitle="Update Chart Account"
          headerDescription="Make changes to your chart account details to keep your financial records accurate and up-to-date."
          style={{ height: "auto" }}
        >
          <secondaryComponents.AddChartAccount
            closeWidget={() => setSelectedChartAccount(null)}
            handleFetchAccountsList={handleFetchAccountsList}
            isEditMode={true}
            bankInfo={bankInfo}
          />
        </RoutedModal>
      </secondaryComponents.LoaderHelper>

      {/* delete modal */}
      <secondaryComponents.LoaderHelper isLoading={isFetchingBankInfo}>
        <secondaryComponents.Modal
          isActive={selectedDeleteAccount !== null}
          closeModal={() => setSelectedDeleteAccount(null)}
          width={500}
        >
          <secondaryComponents.BankAccountDeletion
            closeWidget={() => setSelectedDeleteAccount(null)}
            bankDetails={bankInfo}
            selectedDeleteAccount={selectedDeleteAccount}
            handleFetchAccountsList={handleFetchAccountsList}
          />
        </secondaryComponents.Modal>
      </secondaryComponents.LoaderHelper>
      {/* delete modal */}
    </div>
  );
};

export default AllAccountsList;
